if(!customElements.get('cart-item')) {
  class CartItem extends HTMLElement {
    constructor() {
      super();
      this.removeButton = this.querySelector('.js-remove');
      this.quantityButtons = this.querySelectorAll('.js-qty-button');
      this.itemKey = this.getAttribute('data-js-item-key');
      this.currentQuantity = Number(this.getAttribute('data-js-quantity'));
      this.bundleId = this.getAttribute('data-js-bundle-id');
      this.bundlePiece = this.getAttribute('data-js-bundle-piece');
      this.bundleMain = this.getAttribute('data-js-bundle-main');
      this.cartItems = this.parentNode;
    }

    initRemoveButton() {
      if(!this.removeButton) return;

      this.removeButton.addEventListener('click', (event) => {
        event.preventDefault();
        /*
        if the product we want to remove is part of a bundle we want to remove all associated items, otherwise we remove the product as usual.
        */
        if(this.bundleId && !this.bundlePiece){
          this.removeBundledItems(this.bundleId);
        } else {
          /*
            if a bundle item has somehow triggered this function, we will trust it is a piece-meal bundle where the customer may remove a piece at the expense of losing a bundle discount.
          */
          this.handleQuantityChange(0, 0);
        }
      });
    }

    removeBundledItems(bundleId){
      // collect all the items belonging to the bundle
      const bundleItems = this.cartItems.querySelectorAll(`cart-item[data-js-bundle-id="${bundleId}"]`);
      // build our update body
      let bundle = {};
      let membershipBundle = false;
      let membershipHandle = ""
      bundleItems.forEach((bundleItem)=>{
        bundle[bundleItem.getAttribute('data-js-item-key')] = 0;
        if(bundleItem.getAttribute('data-js-bundle-membership') === "true"){
          membershipBundle = true;
          membershipHandle = bundleItem.getAttribute('data-js-handle');
        }
      });

      fetch(`${window.theme.routes.cart_update_url}.js`, {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ updates: bundle } )
      })
      .then(res => res.json())
      .then(data => {
        const cartDrawer = this.closest('cart-drawer');
        if(cartDrawer) cartDrawer.refresh();

        if(membershipBundle){
          document.dispatchEvent(new CustomEvent("cart:membership-bundle:removed", { detail:
            {
              "membership": membershipHandle
            }
          }));
        }
      })
      .catch(err => console.error(err));
    }

    handleQuantityChange(addedQuantity, multiplier = 1) {
      // console.log(`handleQuantityChange(addedQuantity: ${addedQuantity}, multiplier: ${multiplier})`);
      if (!this.itemKey) {
        this.itemKey = this.getAttribute('data-js-item-key');
      }

      const newQuantity = (this.currentQuantity + addedQuantity) * multiplier;

      let cart_updates = {}

      if(this.bundleId && this.bundlePiece){
        if(newQuantity !== 0){
          /*
            If we are not completely removing a bundle item from the cart, we need to keep the parts in sync.
          */
          const bundleItems = this.cartItems.querySelectorAll(`cart-item[data-js-bundle-id="${this.bundleId}"]`);
          bundleItems.forEach((bundleItem)=>{
            cart_updates[bundleItem.getAttribute('data-js-item-key')] = newQuantity;
          });
        } else {
          // if the intent is to set the quantity to 0, only remove the triggering cart item.
          cart_updates[this.itemKey] = 0;
        }
      } else {
        cart_updates[this.itemKey] = newQuantity;
      }

      fetch(`${window.theme.routes.cart_update_url}.js`, {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ updates: cart_updates } )
      })
      .then(res => res.json())
      .then(data => {
        const cartDrawer = this.closest('cart-drawer');
        if(cartDrawer) cartDrawer.refresh();
        // dispatch an update event, no need to send any extra information.
        document.dispatchEvent(new CustomEvent('cart:item:updated'));
      })
      .catch(err => console.error(err));
    }

    initQuantityButtons() {
      this.quantityButtons = this.querySelectorAll('.js-qty-button');
      if(!this.quantityButtons) return;

      this.quantityButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          const action = Number(button.getAttribute('data-js-action'));
          this.handleQuantityChange(action, 1);
        });
      });
    }

    connectedCallback() {
      this.initRemoveButton();
      this.initQuantityButtons();
    }
  }

  customElements.define('cart-item', CartItem);
}
